enum RoboticMowerCommand {
  PARK = 'PARK',
  START = 'START',
  PERFORM_FOTA = 'PERFORM_FOTA',
  UPDATE_SETTINGS = 'UPDATE_SETTINGS',
}

export default RoboticMowerCommand;
